var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIconMultifamilycomplex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(409 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.668,1.5a.6.6,0,0,0-.591.6V8.654H3.885V7.462H2.692V8.654h-.3a.9.9,0,0,0-.894.894V17H18.192V7.163a.9.9,0,0,0-.894-.894H14.615V4.607a.6.6,0,0,0-.424-.571l-.768-.231V1.5H12.231V3.447l-1.192-.359V1.5H9.846V2.73l-4-1.2A.6.6,0,0,0,5.668,1.5Zm.6,1.4,7.154,2.154V15.808H11.038v-1.3a1.788,1.788,0,1,0-1.192,0v1.3H7.462V9.548a.9.9,0,0,0-.894-.894h-.3ZM7.462,6.269V7.462h4.769V6.269Zm7.154,1.192H17v8.346H14.615V14.615h1.192V13.423H14.615V12.231h1.192V11.038H14.615V9.846h1.192V8.654H14.615ZM8.654,8.654V9.846h3.577V8.654ZM2.692,9.846H6.269v5.962H2.692Zm1.192,1.192v1.192H5.077V11.038Zm0,2.385v1.192H5.077V13.423Z",
    transform: "translate(409.154 773.75)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconMultifamilycomplex);
export default __webpack_public_path__ + "static/media/property-icon-multifamilycomplex.3efaa1f3d3a9818b22b6c9000be8703c.svg";
export { ForwardRef as ReactComponent };